import { batchActions } from 'redux-batched-actions';

import http from './http';
import * as storage from '../utils/storage';
import * as ConfigActions from '../actionTypes/config';
import { filterIntegrations } from '../utils/config';

export function setConfig(key, value) {
    return {
        type: ConfigActions.SET_CONFIG,
        key,
        value,
    };
}

export function resetConfig() {
    return {
        type: ConfigActions.RESET_CONFIG,
    };
}

export function setLocalSettings(settings) {
    return {
        type: ConfigActions.SET_LOCAL_SETTINGS,
        settings,
    };
}

export function setRemoteSettings(settings) {
    return {
        type: ConfigActions.SET_REMOTE_SETTINGS,
        settings,
    };
}

function migrateStoragePrefix(appId, integrationId) {
    const [appClientId, appAppUserId, appSessionToken] = storage.getItems(appId, [
        'clientId',
        'appUserId',
        'sessionToken',
    ]);
    const [integrationAppUserId, integrationSessionToken] = storage.getItems(integrationId, [
        'appUserId',
        'sessionToken',
    ]);

    // copy step:

    if (appClientId && appAppUserId && appSessionToken) {
        if (!integrationAppUserId || !integrationSessionToken) {
            storage.setItems(integrationId, {
                clientId: appClientId,
                appUserId: appAppUserId,
                sessionToken: appSessionToken,
            });
        }
    }

    if (appClientId && !(integrationAppUserId || integrationSessionToken)) {
        storage.setItem(`${integrationId}.clientId`, appClientId);
    }

    // cleanup step:
    storage.removeItems(appId, ['clientId', 'appUserId', 'sessionToken']);
}

function getConfigUrl({ appId, integrationId }) {
    // `integrationId` has priority over `appId` since v4.29.
    // `appId` is only supported for backward compatibility purposes.
    if (integrationId) {
        return `/v2/integrations/${integrationId}/config`;
    }

    return `/apps/${appId}/config`;
}

export function fetchConfig() {
    return (dispatch, getState) => {
        const configState = getState().config;
        const { configBaseUrl } = configState;

        return dispatch(
            http(
                'GET',
                getConfigUrl({ appId: configState.appId, integrationId: configState.integrationId }),
                {},
                {},
                configBaseUrl,
            ),
        ).then(({ config }) => {
            const appId = config.app._id;
            const integrationId = config.integration._id;

            const actions = Object.keys(config)
                .filter((key) => {
                    return !['style', 'prechatCapture'].includes(key);
                })
                .map((key) => {
                    if (key === 'integrations') {
                        return setConfig(key, filterIntegrations(config[key]));
                    }

                    if (key === 'app') {
                        migrateStoragePrefix(appId, integrationId);
                        return setConfig('appId', appId);
                    }

                    if (key === 'integration') {
                        return setConfig('integrationId', integrationId);
                    }

                    return setConfig(key, config[key]);
                });

            const remoteSettings = {
                ...config.style,
                prechatCapture: config.prechatCapture,
            };

            if (config.app) {
                if (config.app.name) {
                    remoteSettings.businessName = config.app.name;
                }

                if (config.app.iconUrl) {
                    remoteSettings.businessIconUrl = config.app.iconUrl;
                }
            }

            actions.push(setRemoteSettings(remoteSettings));
            actions.push(setConfig('isAppActive', config.app && config.app.status === 'active'));
            actions.push(setConfig('apiBaseUrl', config.baseUrl.web));

            dispatch(batchActions(actions));
        });
    };
}
